import { useAuth } from "@/contexts/AuthContext";
import { queryConfirmationNames } from "@/services/EventService";
import axios from "axios";
import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Check, ShieldQuestionMark, X } from "lucide-react";
import { useNotify } from "@/contexts/NotifyContext";
import { NavBack } from "../layout/Menu/NavBack";

type dataType = {
    id: number;
    year: number;
    name: string;
    classes: string;
    confirmation: number;
}

export function ChartConfirmationNames({ eventId, year, callback }: { 
    eventId: number;
    year: number;
    callback: () => void;
}) {
    const { setToken } = useAuth();
    const { setNotify } = useNotify();
    const [data, setData] = useState<dataType[]>([]);

    useEffect(() => {
        setNotify(null);
        setToken(axios);
        queryConfirmationNames(eventId, Number(year)).then(
            (recs: any) => {
                // console.log(recs);
                let result: dataType[] = [];
                for (let i = 0; i < recs.length; i++) {
                    const rec = recs[i];
                    result.push({
                        id: rec.Id,
                        year: rec.Graduation,
                        name: rec.Name,
                        classes: rec.Classes,
                        confirmation: rec.Confirmation
                    });
                }
                setData(result);
            }, (error: any) => {
                setNotify({ title: "Konfirmasi Gagal", error, severity: 'error' });
            }
        )
    }, [year]);

    function statusIcon(status: number) {
        switch (status) {
            case 0: return <div className="flex flex-row text-xs"><ShieldQuestionMark size={16} />belum tahu</div>;
            case 1: return <div className="flex flex-row text-xs"><Check size={16} /> insyaAllah hadir</div>;
            case 2: return <div className="flex flex-row text-xs">? mungkin hadir</div>;
            case 3: return <div className="flex flex-row text-xs"><X size={16} />tidak hadir</div>;
            default: return;
        }
    }

    return (
        <div className="flex flex-col gap-2 items-center justify-center">
        <NavBack />
            <h4 className="text-center font-bold">Konfirmasi Kehadiran Angkatan {year}</h4>
            <div className="max-w-100">
                <div className="max-h-100 overflow-auto border">
                    <Table className="">
                        <TableHeader>
                            <TableRow>
                                <TableHead className="text-left">Nama</TableHead>
                                <TableHead className="text-right" >Konfirmasi</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {data.map((rec, i) => (
                                <TableRow key={i}>
                                    <TableCell className="text-left p-1">{rec.name} </TableCell>
                                    <TableCell className="text-center p-1">{statusIcon(rec.confirmation)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div className="mt-3 w-full">
                    <button type="button" onClick={callback} className="w-full rounded-md mb-2.5 p-2.5 bg-[#f8ad3c] text-white cursor-pointer opacity-80 hover:opacity-100">
                        Kembali
                    </button>
                </div>
            </div>
        </div>
    )
}